import React from 'react';

const groupingOptions = [
    { value: 'none', label: 'No Grouping' },
    { value: 'issue', label: '🎫 Group by Issue' },
    { value: 'Parent', label: '🌳 Group by Parent' },
    { value: 'worklogAuthor', label: '👤 Group by Worklog Author' },
    { value: 'issueAssignee', label: '🎯 Group by Issue Assignee' },
    { value: 'project', label: '📁 Group by Project' },
    { value: 'status', label: '📊 Group by Status' },
    { value: 'priority', label: '🏷️ Group by Priority' },
    { value: 'sprint', label: '🏃 Group by Sprint' },
    { value: 'date', label: '📅 Group by Date' }
  ];
    

const GroupingDropdown = ({ grouping, onGroupingChange }) => {
  return (
    <div className="flex items-center space-x-2 min-w-0 w-full sm:w-auto">
      <select
        value={grouping?.field || 'none'}
        onChange={(e) => onGroupingChange(e.target.value)}
        className="px-3 py-2 border rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 text-sm bg-white dark:bg-slate-900 border-gray-300 dark:border-white/20 text-gray-900 dark:text-slate-100 min-w-0 flex-1 sm:flex-none"
      >
        {groupingOptions.map(option => (
          <option
            key={option.value}
            value={option.value}
            className="bg-white dark:bg-slate-900 text-gray-900 dark:text-slate-100"
          >
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default GroupingDropdown;

